import { ExperienceList } from "../../../../src/components/experience-list.js";
import { GrGraphQl } from "react-icons/gr";
import { RiFileDownloadLine } from "react-icons/ri";
import { ExternalLink } from "../../../../src/components/ExternalLink.js";
import { RepositoryList } from "../../../../src/components/RepositoryList.js";
import resume from "../../../../static/assets/Resume.pdf";
import * as React from 'react';
export default {
  ExperienceList,
  GrGraphQl,
  RiFileDownloadLine,
  ExternalLink,
  RepositoryList,
  resume,
  React
};